import { z } from 'zod'

import { apiClient } from '@/shared/api'

import * as mapLogger from './logger'
import { TLandmarkMarker, TRegionMarker, TSubwayMarker } from '../model/schema'

export const ZSearchKeywordSearchParams = z.object({
  keyword: z.string(),
  maxSize: z.number().optional(),
})

export type TSearchKeywordSearchParams = z.infer<
  typeof ZSearchKeywordSearchParams
>

export type TSearchKeywordResponse = {
  regions: TRegionMarker[]
  subways: TSubwayMarker[]
  landmarks: TLandmarkMarker[]
}

export const getSearchKeywords = async (params: TSearchKeywordSearchParams) => {
  const { data } = await apiClient.get<TSearchKeywordResponse>({
    endpoint: `/map/search-keywords`,
    queryParams: params,
  })

  const regionCount = data.regions.length
  const subwayCount = data.subways.length
  const landmarkCount = data.landmarks.length

  const logData = {
    keyword: params.keyword,
    dataCount: {
      regions: regionCount,
      subways: subwayCount,
      landmarks: landmarkCount,
      total: regionCount + subwayCount + landmarkCount,
    },
  }

  await mapLogger.searchKeywords(logData)

  return data
}
